import styles from './consent.module.sass';
import { Text, CustomScroll, FontIcon } from '@intigral/shared';

export interface ConsentProps extends React.HTMLAttributes<HTMLDivElement> {
    title?: string;
    info?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    /** `full`: mandatory T&C iframe; `fit`: shorter optional screen */
    variant?: 'full' | 'fit';
}

export const Consent = ({ title, info, children, footer, variant = 'full', ...props }: ConsentProps) => {
    const isFit = variant === 'fit';
    return (
        <div className={`${styles.holder} ${isFit ? styles['holder--fit'] : ''}`}>
            <div className={`${styles.consent} ${isFit ? styles['consent--fit'] : ''}`} {...props}>
                <Text as="h2" variant="h2" margin={{ default: '2x', md: '3x' }} size={{ default: '22', md: '32' }}>
                    {title}
                </Text>
                <div className={styles.content}>
                    {info && (
                        <div className={styles.info}>
                            <FontIcon name="info" color="gray" size="smaller" md="smaller" />
                            {info}
                        </div>
                    )}
                    {children}
                </div>
                <div className={styles.footer}>{footer}</div>
            </div>
        </div>
    );
};
